import { useLocalSearchParams } from 'expo-router'
import { useEffect } from 'react'
import { KeyboardAvoidingView, Platform } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import FormEntries from '@/modules/formEntries/FormEntries'
import { closePublishSheet } from '@/redux/slices/publishSheetSlice'
import { useAppDispatch } from '@/redux/store'
import FormStackScreen from './FormStackScreen'

export default function FormEntriesPage() {
  const insets = useSafeAreaInsets()
  const { formToken, ...searchParams } = useLocalSearchParams<{ formToken: string }>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(closePublishSheet())
    }
  }, [dispatch])

  return (
    <KeyboardAvoidingView
      className="flex-1"
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}
    >
      <FormStackScreen
        formToken={formToken}
        titlePrefix="数据"
        defaultBackHref={`/forms/${formToken}`}
        headerTransparent={false}
      />
      <FormEntries formToken={formToken} searchParams={searchParams as Record<string, string>} />
    </KeyboardAvoidingView>
  )
}
